/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks\useWorldMapControls.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the geoFirewall module.
────────────────────────────────────────────────────────────────*/


import { RefObject } from 'react';

const wheelZoom = (container: HTMLDivElement, deltaY: number) => {
    const rect = container.getBoundingClientRect();
    container.dispatchEvent(new WheelEvent('wheel', {
        deltaY,
        clientX: rect.left + container.clientWidth / 2,
        clientY: rect.top + container.clientHeight / 2,
        bubbles: true,
        cancelable: true,
    }));
};

export function buildWorldMapControls(
    mapInstanceRef: RefObject<any>,
    mapContainerRef: RefObject<HTMLDivElement>,
) {
    return {
        focusCountry: (code: string) => {
            try { mapInstanceRef.current?.setFocus({ region: code, animate: true }); }
            catch (e) { console.error('Error focusing country:', e); }
        },
        zoomIn: () => { if (mapContainerRef.current) wheelZoom(mapContainerRef.current, -100); },
        zoomOut: () => { if (mapContainerRef.current) wheelZoom(mapContainerRef.current, 100); },
        reset: () => {
            const map = mapInstanceRef.current;
            if (map && typeof map.reset === 'function') { try { map.reset(); } catch (e) { console.error('Error resetting map:', e); } }
        },
    };
}
